module.exports = __webpack_public_path__ + "img/manual-2.e914d9e1.png";